
import clienteAxios from "../config/axios";

export const getAllControl = async () => {
    return clienteAxios.get('/control');
};
export const addControl = async (control) => {
    return await clienteAxios.post('/control',{control});
}
export const updateControl = async (control) => {
    return await clienteAxios.put(`control/${control.id}`,{control});
}
export const deleteControl = async (id, checklistID) => {
    return await clienteAxios.delete(`control/${id}`,{data:{tDocID:checklistID}});
}